export * from './AsteriskSound.js'
export * from './AddressBookEntry.js'
export * from './Call.js'
export * from './Campaign.js'
export * from './CampaignDisposition.js'
export * from './CampaignList.js'
export * from './CampaignListRecord.js'
export * from './Callback.js'
export * from './CampaignListRecordContactDetails.js'
export * from './Channel.js'
export * from './ChannelConsumers.js'
export * from './ChannelOutcome.js'
export * from './ChannelSession.js'
export * from './ChannelSessionMessages.js'
export * from './Dashboard.js'
export * from './DoNotDial.js'
export * from './Events.js'
export * from './Extension.js'
export * from './Form.js'
export * from './FormAnswer.js'
export * from './JasperReport.js'
export * from './LicenseType.js'
export * from './Organization.js'
export * from './OrganizationDisposition.js'
export * from './PauseCode.js'
export * from './Plugin.js'
export * from './Queue.js'
export * from './Roles.js'
export * from './Steps.js'
export * from './Team.js'
export * from './TransferCallLog.js'
export * from './Trunk.js'
export * from './User.js'
export * from './UserLicenseToken.js'
export * from './VoicemailMessage.js'
export * from './WorkFlow.js'
export * from './UserDevice.js'
export * from './EarlyAnswerStrategy.js'
export * from './WorkflowExecutionLog.js'

import { AddressBookEntry } from './AddressBookEntry.js'

import { Campaign } from './Campaign.js'
import { CampaignListRecord } from './CampaignListRecord.js'
import { CampaignListRecordContactDetails } from './CampaignListRecordContactDetails.js'
import { DoNotDial } from './DoNotDial.js'
import { Extension } from './Extension.js'
import { Organization } from './Organization.js'
import { Role } from './Roles.js'
import { Team } from './Team.js'
import { Trunk } from './Trunk.js'
import { User } from './User.js'
import { UserLicenseToken } from './UserLicenseToken.js'
import { LicenseType } from './LicenseType.js'
import { PaginationResponseMeta } from '../interfaces/index.js'
import { AsteriskSound } from './AsteriskSound.js'
import { Call } from './Call.js'
import { CampaignDisposition } from './CampaignDisposition.js'
import { CampaignList } from './CampaignList.js'
import { Callback } from './Callback.js'
import { Channel } from './Channel.js'
import { ChannelConsumer } from './ChannelConsumers.js'
import { ChannelOutcome } from './ChannelOutcome.js'
import { ChannelSession } from './ChannelSession.js'
import { ChannelSessionMessage } from './ChannelSessionMessages.js'
import { Dashboard } from './Dashboard.js'
import { Form } from './Form.js'
import { FormAnswer } from './FormAnswer.js'
import { JasperReport } from './JasperReport.js'
import { OrganizationDisposition } from './OrganizationDisposition.js'
import { PauseCode } from './PauseCode.js'
import { Plugin } from './Plugin.js'
import { Queue } from './Queue.js'
import { TransferCallLog } from './TransferCallLog.js'
import { VoicemailMessage } from './VoicemailMessage.js'
import { Workflow } from './WorkFlow.js'
import { UserDevice } from './UserDevice.js'
import { EarlyAnswerStrategy } from './EarlyAnswerStrategy.js'
import { WorkflowExecutionLog } from './WorkflowExecutionLog.js'

export type AllTypes =
  | AddressBookEntry
  | User
  | Organization
  | Role
  | Team
  | Extension
  | Campaign
  | Trunk
  | CampaignListRecord
  | CampaignListRecordContactDetails
  | UserLicenseToken
  | LicenseType
  | DoNotDial
  | AsteriskSound
  | Call
  | CampaignDisposition
  | CampaignList
  | Callback
  | Channel
  | ChannelConsumer
  | ChannelOutcome
  | ChannelSession
  | ChannelSessionMessage
  | Dashboard
  | Form
  | FormAnswer
  | JasperReport
  | OrganizationDisposition
  | PauseCode
  | Plugin
  | Queue
  | TransferCallLog
  | VoicemailMessage
  | Workflow
  | UserDevice
  | EarlyAnswerStrategy

  | WorkflowExecutionLog
export type AllMeta = PaginationResponseMeta

export enum EnumTypes {
  EmployeeTypes = 'EmployeeTypes',
  QueueTypes = 'QueueTypes',
  CallTypes = 'CallTypes',
  DiallerTypes = 'DiallerTypes',
  PhoneTypes = 'PhoneTypes',
  FileColumnTypes = 'FileColumnTypes',
  ChannelPlatforms = 'ChannelPlatforms',
  providers = 'providers',
  earlyAnswerStrategies = 'earlyAnswerStrategies',
  trunkGroups = 'trunkGroups',
}
